import React, { useMemo } from 'react';

import { usePokCore } from '../../../common/hooks/usePokCore';
import { useNavigation } from '../../../common/navigation';
import { useAuth } from '../../../common/hooks/useAuth';
import { useTranslation } from '../../../common/hooks/useTranslation';
import {
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { PermissionsEnum } from '../../../common/pokCore/authorization/permissions';

import { ClientGroupSearch } from './ClientGroupSearch';

interface ClientGroupMembershipTabProps {
  clientId: string;
}

export const ClientGroupMembershipTab: React.FC<
  ClientGroupMembershipTabProps
> = props => {
  const pok = usePokCore();
  const nav = useNavigation();
  const auth = useAuth();

  const canOpenGroup = auth.check(PermissionsEnum.Surveys);

  const getData = useMemo(
    () =>
      ((
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
      ) =>
        pok.clientGroups.getAllByPortionForClient(
          props.clientId,
          pageSize,
          pageNumber,
          orderBy,
          orderDirection,
          filterText,
          filterColumns,
        )) as GridGetterFunction,
    [pok.clientGroups, props.clientId],
  );

  const getCount = useMemo(
    () =>
      ((filterText, filterColumns) =>
        pok.clientGroups.getAllCountForClient(
          props.clientId,
          filterText,
          filterColumns,
        )) as GridCountFunction,
    [pok.clientGroups, props.clientId],
  );

  const { t, tk } = useTranslation('clientLng');

  return (
    <ClientGroupSearch
      getData={getData}
      getCount={getCount}
      onRowClick={canOpenGroup ? id => nav.clientGroup(id) : undefined}
      emptyGridMessage={t(tk.clientGroup.noGroupMembership)}
    />
  );
};
